(() => {
  function findCousin(elements, nextOrPrev, selector) {
    // Reference the last of the selected elements
    const reference = elements[elements.length - 1];

    // Set of all elements matching the selector
    const set = Array.from(document.querySelectorAll(selector));

    // Fins the position of the reference element in the set of all elements
    const pos = set.indexOf(reference);

    // If the element does not match the selector for cousin elements return null
    if (set.length === (pos - 1)) return null;

    // Return the next or previous cousin to the reference
    return set[pos + (nextOrPrev === 'next' ? 1 : (-1))];
  }

  // do not execute in edit mode
  const url = window.location.href.toLowerCase();

  if (url.indexOf('/action/edit') > 0 || url.indexOf('/action/inedit') > 0) {
    return;
  }

  let resizing = false;

  function calculateOffsets() {
    document.querySelectorAll('.Section--patch').forEach(patch => {
      const patchHalfHeight = `${Math.ceil(patch.offsetHeight / 2)}px`;
      const isSmall = patch.classList.contains('Section--s');

      if (document.body.offsetWidth > (isSmall ? 1360 : 1460)) {
        const containers = patch.querySelectorAll('.container');
        const prevCousin = findCousin(containers, 'prev', '.container, .PRGS-container');
        const nextCousin = findCousin(containers, 'next', '.container, .PRGS-container');

        patch.classList.add('is-active');

        patch.setAttribute('style', `margin-top: -${patchHalfHeight}; margin-bottom: -${patchHalfHeight}`);

        const customPaddingClass = isSmall ? 'has-custom-padding-s' : 'has-custom-padding';

        if (prevCousin) {
          prevCousin.classList.add(customPaddingClass);
          prevCousin.style.paddingBottom = patchHalfHeight;
        }

        if (nextCousin) {
          nextCousin.classList.add(customPaddingClass);
          nextCousin.style.paddingTop = patchHalfHeight;
        }
      }
    });
  }

  if (!document.querySelector('.sfPageEditor') && document.querySelector('.Section--patch')) {
    window.addEventListener('resize', () => {
      resizing = true;
    });

    window.setInterval(() => {
      if (resizing) {
        calculateOffsets();
        resizing = false;
      }
    }, 500);

    calculateOffsets();
  }
})();
